/*
  Cambiar el color de una linea del carrito sin recargar la pagina.

  El enlace del snippet ya funciona solo: apunta a /cart/update con las dos
  instrucciones, el navegador hace GET, Shopify responde 302 y vuelve a /cart.
  Este fichero solo evita el salto. Si algo falla, se deja pasar el clic al
  enlace y el cliente acaba igual de bien, solo que con una recarga.

  El intercambio es una sola llamada a /cart/update.js: la linea vieja a cero y
  la nueva variante con la cantidad final, que el Liquid ya calculo sumando lo
  que hubiera de ese color. Esa misma llamada admite renderizado de secciones,
  asi que no hace falta una segunda peticion para repintar.

  No se toca la burbuja del carrito a proposito: cambiar de color no cambia el
  numero de unidades, asi que repintarla seria trabajo para dejarla igual.
*/
(function () {
  'use strict';

  var contenedor = document.getElementById('main-cart-items');
  if (!contenedor) return;

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Las secciones se leen ANTES del fetch: al repintar, los nodos actuales
  // desaparecen y con ellos su data-id.
  function seccionesARepintar() {
    var lista = [];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) lista.push({ id: id, seccion: el.dataset.id });
    });
    return lista;
  }

  // El HTML viene del renderizado de secciones de la propia tienda, servido por
  // Shopify a partir de este mismo tema: es nuestro Liquid, no entrada de
  // usuario. Es como repinta Dawn su carrito.
  function contenidoDe(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var trozo = doc.querySelector('.js-contents');
    return trozo ? trozo.innerHTML : null;
  }

  contenedor.addEventListener('click', function (e) {
    var enlace = e.target.closest('[data-lander-swap-destino]');
    if (!enlace) return;
    // Ctrl/cmd-clic, botón central, abrir en pestaña: que mande el navegador.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

    e.preventDefault();
    if (enlace.getAttribute('aria-busy') === 'true') return;
    enlace.setAttribute('aria-busy', 'true');

    // Marca la frontera: antes de que el servidor conteste, el remedio es seguir
    // el enlace; despues, el cambio YA esta hecho y seguirlo seria repetirlo.
    // Es inofensivo porque updates[] fija cantidades absolutas y repetirlo deja
    // el mismo carrito, pero recargar dice la verdad de lo que ha pasado.
    var yaCambiado = false;
    var secciones = seccionesARepintar();
    var updates = {};
    updates[enlace.dataset.landerSwapLinea] = 0;
    updates[enlace.dataset.landerSwapDestino] = parseInt(enlace.dataset.landerSwapCantidad, 10) || 1;

    fetch(raiz + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: secciones.map(function (s) { return s.seccion; }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('no se pudo cambiar');
        yaCambiado = true;
        return r.json();
      })
      .then(function (carrito) {
        if (!carrito.sections) throw new Error('sin secciones');

        // Se prepara todo antes de tocar el DOM. Repintar la mitad del carrito
        // es peor que no repintar nada: el cliente ve un total que no cuadra
        // con las lineas y deja de fiarse de la pagina.
        var parches = secciones.map(function (s) {
          var destino = document.getElementById(s.id);
          var hueco = destino && destino.querySelector('.js-contents');
          var nuevo = carrito.sections[s.seccion] != null ? contenidoDe(carrito.sections[s.seccion]) : null;
          if (!hueco || nuevo === null) throw new Error('falta la seccion ' + s.id);
          return { hueco: hueco, html: nuevo };
        });
        parches.forEach(function (p) { p.hueco.innerHTML = p.html; });

        document.dispatchEvent(new CustomEvent('lander:carrito-cambiado', { detail: carrito }));
      })
      .catch(function () {
        // El enlace sigue siendo un enlace de verdad. Si el camino corto falla,
        // se toma el largo en vez de dejar al cliente con un botón muerto.
        if (yaCambiado) {
          window.location.reload();
        } else {
          window.location.href = enlace.href;
        }
      });
  });
})();
